import { LanguageProvider } from 'context/language';

const providers = [
  LanguageProvider,
];

export default providers;
